import { UserOutlined } from "@ant-design/icons";
import { Box, Divider, useMediaQuery, useTheme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Facebook,
  Instagram,
  SearchOutlined,
  Twitter,
  YouTube,
} from "@material-ui/icons";
import { Grid, IconButton } from "@mui/material";
import { Input } from "antd";
import Axios from "axios";
import { PrimaryButton } from "components";
import { useEffect, useState } from "react";
import "react-redux";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import "../assets/css/layout.css";
import companyLogo from "../assets/img/company_logo.png";
import CARIS from "../assets/img/newCarisLogo.webp";
import logoLight from "../assets/img/newMpisLogo.webp";
import supported from "../assets/img/supported-img.png";
import {
  getSubdomainFromCurrentURL,
  hardBaseUrl,
  hardSubDomain,
  hardTypeWeb,
} from "../services/urlConstant";
import MobileNavbar from "./MobileNavbar";

const useStyles = makeStyles(() => ({
  landingNavbarSearchIcon: {
    height: "32px",
    width: "32px",
  },
  landingNavbarMenu: {
    fontSize: 18,
    color: "#687083",
  },
  landingNavbarContainer: {
    height: "90px",
    position: "fixed",
    backgroundColor: "white",
    width: "100%",
    zIndex: 4,
    borderBottom: "1px solid whitesmoke",
    boxShadow: "0px 1px 5px 0px rgb(173, 173, 173)",
    display: "flex",
    alignItems: "center",
    padding: "0 120px",
  },

  loginButton: {
    backgroundColor: "black",
    color: "white",
    border: "none",
    width: 106,
    height: 44,
    borderRadius: 5,
    marginLeft: 20,
  },
  logo: {
    maxWidth: 174,
    width: "100%",
    padding: 0,
    height: "auto",
    maxHeight: "80px",
    shadow: "none",
    fill: "contain",
  },
  logoMobileContainer: {
    width: "100px",
  },
  searchButton: {
    border: "none",
    marginLeft: 10,
  },
  companyContainer: {
    display: "flex",
    alignItems: "center",
  },
  menuContainer: {
    display: "flex",
    alignItems: "center",
  },
  rightMenuContainer: {
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-end",
  },
  searchBar: {
    height: "100%",
    marginLeft: "170px",
    marginRight: "180px",
  },
  inputSearch: {
    height: "100%",
    borderRadius: "6px",
    color: "black",
  },
  searchWrapper: {
    color: "white",
  },
  searchHeading: {
    color: "white",
    marginTop: "20px",
  },
  searchResult: {
    marginRight: "10px",
  },
  searchDivider: {
    marginTop: "20px",
    marginBottom: "20px",
  },
  footer: {
    height: "auto",
  },
  footerMobile: {
    height: "200px",
    backgroundColor: "#111827",
  },
  footerMobileContent: {
    paddingTop: "10px",
    paddingLeft: "10px",
  },
  contactTitle: {
    marginTop: "10px",
    fontSize: "12px",
    fontWeight: "bold",
    color: "white",
  },
  contactText: {
    color: "white",
  },
  socialIcons: {
    display: "flex",
    marginTop: "10px",
  },
  socialIcon: {
    color: "white",
    marginLeft: "10px",
  },
  firstSocialIcon: {
    color: "white",
  },
  footerLink: {
    color: "white",
  },
  footerLinkWithMargin: {
    color: "white",
    marginLeft: "20px",
  },
  footerLinkContainer: {
    display: "flex",
    marginTop: "20px",
  },
  supportedBy: {
    textAlign: "right",
  },
  footerDivider: {
    borderColor: "white",
    width: "100%",
    marginTop: "30px",
    marginBottom: "10px",
  },
  carisLogoContainer: {
    backgroundColor: "white",
    width: "209px",
    padding: "10px",
  },
  carisLogo: {
    height: "32px",
  },
  contactSupport: {
    marginTop: "10px",
    fontSize: "12px",
    fontWeight: "bold",
  },
  socialIconsContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  logoBottomContainer: {
    maxWidth: 200,
    maxHeight: 80,
    display: "flex",
    justifyContent: "center",
  },
}));

export default function Layout(params) {
  const classes = useStyles();
  const isMpis = hardTypeWeb === "mpis";
  const subDomain = getSubdomainFromCurrentURL();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { children } = params;
  const [search, setSearch] = useState(false);
  const [dataSearch, setDataSearch] = useState({
    artists: [],
    composers: [],
    songs: [],
  });
  const [input, setInput] = useState("");
  const [imageChoosen, setImageChoosen] = useState("");
  const isPreview = location.pathname === "/admin/manajemen-web/preview";

  const checkLogo = async () => {
    try {
      const newUrl = `${hardBaseUrl}/landing/publisher/detail?subdomain=${subDomain}&type=${hardTypeWeb}`;
      const response = await Axios.get(newUrl);
      if (response?.data?.data) {
        setImageChoosen(response.data.data);
      }
    } catch (error) {
      console.error("Error in checkLogo:", error);
    }
  };

  const handleSearch = async val => {
    setInput(val);
    try {
      const response = await Axios.get(
        `${hardBaseUrl}/search/song/suggestion?search=${val}&subdomain=${hardSubDomain}`
      );
      setDataSearch(response.data.data);
    } catch (error) {
      new Error(error);
    }
  };

  const handleRedirect = (a, b) => {
    setSearch(false);
    history.push({
      pathname: "/detail-lagu",
      search: `?search=${b}?field=${a}`,
      state: {
        search: b,
        field: a,
      },
    });
    setInput("");
    window.location.reload();
  };

  useEffect(() => {
    checkLogo();
  }, []);

  const getLogoMobile = item => {
    if (hardTypeWeb === "caris") {
      if (hardSubDomain === "nadaku") {
        return <img src={item} alt="logo" width="76px" />;
      } else if (hardSubDomain === "aquarius") {
        return <img src={item} alt="logo" className="logo" />;
      } else if (hardSubDomain === null) {
        return (
          <img
            src={item}
            alt="logo"
            className="logo"
            style={classes.logoMobileContainer}
          />
        );
      } else {
        return <img src={item} alt="logo" />;
      }
    } else if (hardTypeWeb === "mpis") {
      return <img src={companyLogo} alt="logo" className="logo" />;
    }
  };

  return (
    <div className={isMobile ? null : "fill-window"} id="fill-window">
      {!isPreview && (
        <>
          {isMobile ? (
            <MobileNavbar logo={getLogoMobile(imageChoosen)} />
          ) : (
            <Box className={classes?.landingNavbarContainer}>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <Grid container alignItems="center" columnGap={7}>
                    <Grid item>
                      <img
                        alt="Logo"
                        src={isMpis ? companyLogo : imageChoosen}
                        className={classes.logo}
                      />
                    </Grid>
                    {navMenu(false)?.map(({ label, url }, index) => (
                      <Grid item key={index}>
                        <Link
                          to={!isPreview && url}
                          className={classes?.landingNavbarMenu}
                        >
                          {label}
                        </Link>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid container alignItems="center" columnGap={2}>
                    <Grid item>
                      <IconButton
                        onClick={() => {
                          setSearch(!search);
                          setInput("");
                        }}
                      >
                        <SearchOutlined
                          className={classes?.landingNavbarSearchIcon}
                        />
                      </IconButton>
                    </Grid>
                    <Grid item>
                      <Link
                        to={"/login"}
                        state={{
                          noFooter: true,
                        }}
                      >
                        <PrimaryButton
                          label="Login"
                          size="large"
                          width="106px"
                          color="#111827"
                        />
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          )}
          {!isMobile && (
            <Box
              className="search-bar"
              style={{
                marginTop: search ? "90px" : "0px",
                zIndex: search && 3,
              }}
            >
              <div className={`container content ${classes.searchBar}`}>
                <Input
                  className={`input-search ${classes.inputSearch}`}
                  onChange={e => handleSearch(e.target.value)}
                  value={input}
                  prefix={<SearchOutlined />}
                  size="large"
                  placeholder="Search for a song, singer or composer"
                />
                {input !== "" ? <hr className={classes.searchDivider} /> : ""}
                <div
                  className={`search-wrapper ${classes.searchWrapper}`}
                  style={{
                    height: input !== "" ? "400px" : "0px",
                  }}
                >
                  {input !== "" && search && (
                    <>
                      <div className={classes.searchWrapper}>
                        <h4 className={classes.searchHeading}>Song</h4>
                        {dataSearch.songs.map((res, index) => {
                          return (
                            <div
                              className="result-search"
                              onClick={() => handleRedirect("songs", res)}
                              key={`${index}`}
                            >
                              <i
                                className="fa fa-music"
                                style={classes.searchResult}
                              />{" "}
                              {res}
                            </div>
                          );
                        })}
                        <h4 className={classes.searchHeading}>Composer</h4>
                        {dataSearch.composers.map((res, index) => {
                          return (
                            <div
                              className="result-search"
                              onClick={() => handleRedirect("composers", res)}
                              key={`${index}`}
                            >
                              <UserOutlined className={classes.searchResult} />{" "}
                              {res}
                            </div>
                          );
                        })}
                        <h4 className={classes.searchHeading}>Artist</h4>
                        {dataSearch.artists.map((res, index) => {
                          return (
                            <div
                              className="result-search"
                              onClick={() => handleRedirect("artist", res)}
                              key={`${index}`}
                            >
                              <UserOutlined className={classes.searchResult} />{" "}
                              {res}
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </Box>
          )}
        </>
      )}
      <div className="children" id="children">
        {children}
      </div>
      <Box
        bgcolor="#051239"
        py={isMobile ? 2 : "32px"}
        px={isMobile ? 1 : "120px"}
        color="white"
      >
        <Grid container my={!isMobile && 2}>
          <Grid item xs={9}>
            <Box bgcolor="white" width="210px" p={2}>
              <img
                src={isMpis ? logoLight : imageChoosen ? imageChoosen : CARIS}
                alt="company-logo"
                height="32px"
              />
            </Box>
            {!isMobile && (
              <Grid container columnGap={2} my={2}>
                {navMenu(true)?.map(({ label, url }, index) => (
                  <Grid item key={index}>
                    <Link
                      to={!isPreview && url}
                      className={classes?.footerLink}
                    >
                      {label}
                    </Link>
                  </Grid>
                ))}
              </Grid>
            )}
            <Box fontWeight="bold" mt={isMobile && 2}>
              Contact Support
            </Box>
            develeoper@asaba.co.id
          </Grid>
          {!isMobile && (
            <Grid item xs={3} textAlign="right">
              <p>Supported by:</p>
              <img src={supported} alt="" />
            </Grid>
          )}
        </Grid>
        {!isMobile && <Divider className={classes?.footerDivider} />}
        <Grid container justifyContent="space-between" mt={isMobile && 2}>
          {!isMobile && <Grid item>Copyright @ 2021 CARIS, Inc.</Grid>}
          <Grid item>
            <Grid container columnGap={2}>
              {socialMediaLinks?.map(({ icon, url }, index) => (
                <Grid item key={index}>
                  <Link to={!isPreview && url} className={classes?.footerLink}>
                    {icon}
                  </Link>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

const navMenu = footer => [
  { label: "Home", url: "/home" },
  { label: "News", url: "/berita" },
  { label: "Education", url: "/edukasi" },
  { label: "About Us", url: "/tentang-kami" },
  ...(footer ? [{ label: "Privacy Policy", url: "/privacy-policy" }] : []),
];
const socialMediaLinks = [
  { icon: <Twitter />, url: "" },
  { icon: <YouTube />, url: "" },
  { icon: <Facebook />, url: "" },
  { icon: <Instagram />, url: "" },
];
